import { Partial } from '@40seas/entities/common';
import { CreditSafePortfolioEvent } from './credit-safe-portfolio.event.entity';

export class UpdateCreditSafePortfolioEventDto extends Partial(CreditSafePortfolioEvent) {}
